import axios from 'axios';

const upload = (basePath, data) => {
  const formData = new FormData();
  formData.append('file', data);
  return axios.post(basePath, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export default {
  upload,
};
